/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The params for Money Transfer page
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.2.0
 */

import { EBasketType } from '../../modules/app/appConstants';
import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export interface IMoneyTransferRouteConfiguration extends IAppRouterConfiguration {
    basketType: EBasketType;
}

export const MoneyTransferRouteConfiguration: IMoneyTransferRouteConfiguration[] = [
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.moneyTransfer],
        path: RoutePath.moneyTransfer,
        basketType: EBasketType.ACCOUNT,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.moneyTransfer],
        path: RoutePath.moneyTransferAccountId,
        basketType: EBasketType.ACCOUNT,
    },
];
